import Vue from 'vue'
import Router from 'vue-router'
// import Top from '@/components/Top'
import UserReg from '@/components/UserReg'
import PasswordChange from '@/components/PasswordChange'
import Chat from '@/components/Chat'
import MailChat from '@/components/MailChat'
import Repair from '@/components/Repair'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      // path: '/',
      // name: 'Top',
      // component: Top
      path: '/',
      name: 'Chat',
      component: Chat
    },
    {
      path: '/mail',
      name: 'Mail',
      component: MailChat
    },
    {
      path: '/user-reg',
      name: 'UserReg',
      component: UserReg
    },
    // {
    //   path: '/chat',
    //   name: 'Chat',
    //   component: Chat
    // },
    {
      path: '/profile',
      name: 'Profile',
      component: UserReg
    },
    {
      path: '/pw-change',
      name: 'PasswordChange',
      component: PasswordChange
    },
    {
      path: '/repair',
      name: 'Repair',
      component: Repair,
      props: (route) => ({ initProductId: route.query.productId })
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js